export default "__VITE_PUBLIC_ASSET__9217bb47__"